import React from 'react';
import {LayeredImageController} from '../../../../../shared/image-layers/LayeredImageController';
import {LayeredImageComponent} from '../../../../../shared/image-layers/LayeredImageComponent';

interface WifiHeatmapPreviewComponentProps {
    layeredImageController: LayeredImageController;
    className?: string;
    onClick?: (e: React.MouseEvent) => void;
    children: React.ReactNode;
}

export const WifiHeatmapPreviewComponent: React.FC<WifiHeatmapPreviewComponentProps> = (props) => {
    const {layeredImageController, className, onClick, children} = props;

    return (
        <LayeredImageComponent
            layeredImageController={layeredImageController}
            className={className}
            onClick={onClick}
            canvasClassName='wifi-heatmap-canvas-layer'>
            {children}
        </LayeredImageComponent>
    );
};
